'use client';

import { Step, stepTag } from '@ni/nimble-components/dist/esm/step';
import { wrap } from '../utilities/react-wrapper';

export { stepTag };
export { type Step };
export const NimbleStep = wrap(Step);
